export default "__VITE_ASSET__C9XPzE2Q__"